module.exports = function() {
  return new Worker(__webpack_public_path__ + "82bf520d3036a0dfcd57.worker.js");
};